"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoData = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = require("../fonts");
var _Svg = require("../Svg");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var image = function image(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("rect", {
    width: "174",
    height: "118",
    rx: "6",
    fill: "#F5F5F5"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "16",
    width: "16",
    height: "2",
    fill: "#E3E3E3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "26",
    width: "142",
    height: "12",
    rx: "2",
    fill: "#E3E3E3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "58",
    width: "142",
    height: "12",
    rx: "2",
    fill: "#E3E3E3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "42",
    width: "142",
    height: "12",
    rx: "2",
    fill: "#E3E3E3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "74",
    width: "142",
    height: "12",
    rx: "2",
    fill: "#E3E3E3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "90",
    width: "142",
    height: "12",
    rx: "2",
    fill: "#E3E3E3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "75",
    y: "16",
    width: "16",
    height: "2",
    fill: "#E3E3E3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "45",
    y: "16",
    width: "16",
    height: "2",
    fill: "#E3E3E3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "105",
    y: "16",
    width: "16",
    height: "2",
    fill: "#E3E3E3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "135",
    y: "16",
    width: "16",
    height: "2",
    fill: "#E3E3E3"
  }));
};
image.defaultProps = {
  width: "174",
  height: "118",
  viewBox: "0 0 174 118",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var DefaultImage = (0, _styledComponents.default)(function () {
  return /*#__PURE__*/_react.default.createElement(_Svg.Svg, {
    as: image
  });
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 174px;\n"])));
var H5 = (0, _styledComponents.default)(_fonts.H5)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0 0 5px;\n"])));
var Small = (0, _styledComponents.default)(_fonts.Small)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  color: ", ";\n  text-align: center;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var ImageWrapper = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n"])));
var NoData = (0, _styledComponents.default)(function (_ref2) {
  var title = _ref2.title,
    subtitle = _ref2.subtitle,
    className = _ref2.className,
    button = _ref2.button,
    _ref2$imageComponent = _ref2.imageComponent,
    Image = _ref2$imageComponent === void 0 ? DefaultImage : _ref2$imageComponent;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(ImageWrapper, null, /*#__PURE__*/_react.default.createElement(Image, null)), title && /*#__PURE__*/_react.default.createElement(H5, null, title), subtitle && /*#__PURE__*/_react.default.createElement(Small, null, subtitle), button);
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  flex-grow: 1;\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  & > *:last-child {\n    margin-bottom: 0;\n  }\n"])));
exports.NoData = NoData;